import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function GetPremiosTerraVoucher() {
  const url = `${webservice}/GetPremiosTerraVoucher?usuarioOK=${getCookie('usuarioOk')}`;
  let response = {};

  await superagent
    .get(url)
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body.GetPremiosTerraVoucherResult;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        typeMessage: 'error',
        message: 'Error',
      };
      response = resp;
    });

  return response;
}
